import logo from "../assets/tweezers.svg";
import { Link } from "react-router-dom";

const Policy = () => {
  return (
    <div className="w-screen min-h-screen bg-gray-100">
      {/* Navbar */}
      <nav className="bg-secondary shadow-md p-4 md:px-8 flex w-full items-center justify-between">
        <div className="flex justify-between items-center py-4">
          <Link href="/">
            <img src={logo} alt="Tweezer" className="w-30" />
          </Link>
        </div>

        
        <div className=" justify-between items-center hidden py-4 font-semibold">
          <Link to="/" className="text-white">Home</Link>
        </div>
      </nav>

      <div className="w-full px-4 md:px-8 mt-5">
        <h1 className="text-3xl font-bold">Tweezers Terms of Use and Privacy Policy</h1>
        <p className="mt-3 text-base font-semibold">Effective Date: March 04, 2025</p>

        <div className="flex flex-col gap-2 border-b border-gray-400 p-5">
          <p className="text-base font-medium">
            Welcome to Tweezers (“we,” “us,” or “our”), an AI-powered football match prediction platform designed to provide betting tips for football enthusiasts. By accessing or using Tweezers (the “Platform”), you agree to be bound by these combined Terms of Use and Privacy Policy (collectively, the “Agreement”). If you do not agree with any part of this Agreement, please do not use the Platform.
          </p>
          <p className="text-base font-medium">
            This document governs your use of Tweezers and explains how we collect, use, and protect your information. Please read it carefully.
          </p>
        </div>

        <div className="flex flex-col gap-4 border-b border-gray-400 p-5">
          <h2 className="text-xl font-semibold">Terms of Use</h2>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">1. Overview of Tweezers</h3>
            <p className="text-base font-normal">
              Tweezers uses artificial intelligence (AI) to generate football match predictions intended as betting tips for six major European leagues: the English Premier League (EPL), LaLiga, Bundesliga, Eredivisie, Serie A, and Ligue 1. We offer three subscription plans:
            </p>
            <ul className="list-disc list-inside">
              <li className="text-base font-normal">
                <b>Free Plan:</b> Limited access to basic betting tips and features.
              </li>
              <li className="text-base font-normal">
                <b>Bronze Plan:</b> Enhanced access to betting tips and additional tools.
              </li>
              <li className="text-base font-normal">
                <b>VIP Plan:</b> Premium access to advanced tips, detailed insights, and exclusive content.
              </li>
            </ul>
            <p className="text-base font-normal">
            The Platform is designed to assist users in making informed betting decisions. Predictions are based on historical data, statistical analysis, and AI algorithms.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">2. Eligibility</h3>
            <p className="text-base font-normal">
              To use Tweezers, you must:
            </p>
            <ul className="list-disc list-inside">
              <li className="text-base font-normal">
                Be at least 18 years old (or the legal gambling age in your jurisdiction, if higher).
              </li>
              <li className="text-base font-normal">
                Reside in a jurisdiction where online betting and the use of betting tips are legal.
              </li>
              <li className="text-base font-normal">
                Have the legal capacity to enter into this Agreement.
              </li>
              <li className="text-base font-normal">
                Not be prohibited from using the Platform under applicable laws.
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">3. Account Registration</h3>
            <p className="text-base font-normal">
              To access the full features of Tweezers, you must register an account. During registration, you will be required to provide accurate, complete, and up-to-date information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately if you suspect unauthorized access to your account at <a href="mailto:support@tweezers.app" className="text-blue-500">support@tweezers.app</a>.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">4. Subscription Plans and Payments</h3>
            <p className="text-base font-normal">
              Tweezers offers three subscription plans: Free, Bronze, and VIP. Each plan provides different features and benefits. You can upgrade, downgrade, or cancel your subscription at any time. Payments are processed through third-party payment providers. You agree to pay all applicable fees and charges associated with your subscription plan. For payments done with card through Paystack, this payment&apos;s would automatically renew at the end of the subscription period, unless you cancel your subscription before the end of the current subscription period. Tweezers does not handle bets or payouts; betting occurs through third party platfroms and at your own risk.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">5. Acceptable Use</h3>
            <p className="text-base font-normal">
              You agree to use Tweezers responsibly and in accordance with this Agreement and all applicable gambling laws. You may not:
            </p>
            <ul className="list-disc list-inside">
              <li className="text-base font-normal">
                Use the Platform for illegal gambling activities or in jurisdictions where betting is prohibited.
              </li>
              <li className="text-base font-normal">
                Copy, reproduce, or distribute our betting tips or content without our written permission.
              </li>
              <li className="text-base font-normal">
                Attempt to reverse-engineer, hack, or interfere with the Platform’s AI or systems.
              </li>
              <li className="text-base font-normal">
                Use the Platform to harass, harm, or infringe on the rights of others.
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">6. Intellectual Property</h3>
            <p className="text-base font-normal">
            Everything you see on Tweezers—our betting tips, content, logos, and underlying technology, including the AI algorithms—is either owned by us or licensed to us and protected by copyright, trademark, and other laws. When you use the Platform, you’re granted a limited, non-exclusive, non-transferable license to access it for your personal betting purposes, but this is subject to the terms of this Agreement.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">7. Betting Disclaimer</h3>
            <p className="text-base font-normal">
            Our betting tips are provided “as is” to help you make betting decisions, but we can’t promise they’ll be accurate, profitable, or perfectly suited to your strategy—gambling inherently involves risk, and past performance isn’t a reliable indicator of future results. You’re fully responsible for any bets you place using our tips and for ensuring you’re following local gambling laws, as Tweezers isn’t a gambling operator and doesn’t accept bets, process winnings, or take responsibility for your betting outcomes. Betting can lead to financial loss, so we urge you to only wager what you can afford to lose and to seek professional advice if necessary.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">8. Termination</h3>
            <p className="text-base font-normal">
            We reserve the right to suspend or terminate your account or access to Tweezers at our discretion, with or without notice, if you violate this Agreement, engage in suspected illegal activity, or for any other reason we deem appropriate. If you decide to stop using the Platform, you can cancel your account or subscription anytime through your account settings.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">9. Limitation of Liability</h3>
            <p className="text-base font-normal">
            To the fullest extent allowed by law, Tweezers, along with its affiliates, officers, and employees, won’t be liable for any financial losses, debts, or damages you might incur from using our betting tips or engaging in gambling, nor will we be responsible for any indirect, incidental, or consequential damages tied to your use of the Platform.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">10. Governing Laws</h3>
            <p className="text-base font-normal">
            This Agreement falls under the laws of Nigeria, and any disputes will be resolved according to those laws, regardless of any conflicts of law principles.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-b border-gray-400 p-5">
          <h2 className="text-xl font-semibold">Privacy Policy</h2>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">11. Information we collect</h3>
            <p className="text-base font-normal">
            When you use Tweezers, we gather certain information to deliver and improve our services. This includes personal details like your email address and username when you register, as well as payment information if you subscribe to a paid plan, though this is processed through third-party providers. We also collect usage data about how you interact with the Platform—like which tips you view or pages you visit—along with device details such as your IP address and browser type. Optionally, you might share extra information, such as your favorite team or betting preferences, to customize your experience.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">12. How we use your information</h3>
            <p className="text-base font-normal">
            The information we collect helps us provide and refine Tweezers, powering our AI to generate betting tips and manage your account effectively. We use it to process payments and subscriptions, send you updates, promotional offers, or support messages—though you can opt out of marketing emails—and analyze usage patterns to boost the accuracy of our tips and overall service quality.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">13. How wa share your Information</h3>
            <p className="text-base font-normal">
            We don’t sell your personal information, but we may share it in specific cases to keep Tweezers running smoothly. This includes passing data to service providers who handle things like hosting, payment processing, or analytics—think companies like Stripe or Google Analytics—or sharing it if we’re legally required to do so, such as by gambling authorities or under a court order. If Tweezers is ever involved in a merger, acquisition, or asset sale, your information might be transferred as part of that process.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">14. Data Security</h3>
            <p className="text-base font-normal">
            We take reasonable steps to safeguard your information from unauthorized access or disclosure, using industry-standard security measures. That said, no system is completely foolproof, so while we strive to protect your data, we can’t guarantee absolute security.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">15. Your Rights</h3>
            <p className="text-base font-normal">
            Depending on where you live, you might have certain rights over your personal data, like the ability to access, correct, or delete it, or to opt out of marketing emails and request data portability.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">16. Cookies and Tracking</h3>
            <p className="text-base font-normal">
            To make your experience better and deliver personalized betting tips, we use cookies and similar technologies that track how you use Tweezers and help us understand usage trends. If you’d rather not have cookies, you can adjust your preferences through your browser settings.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">17. Data Retention</h3>
            <p className="text-base font-normal">
            We keep your information as long as your account is active or as necessary to provide our services, but we might hold onto some data longer if we need to meet legal obligations—like gambling regulations—or sort out any disputes that come up.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">18. Children Privacy</h3>
            <p className="text-base font-normal">
            Tweezers isn’t meant for anyone under 18—or the legal gambling age in your area, if it’s higher—and we don’t knowingly collect personal information from minors. If we discover we’ve accidentally gathered data from someone underage, we’ll delete it as soon as possible.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">19. International Data Transfer</h3>
            <p className="text-base font-normal">
            If you’re using Tweezers from outside Nigeria, your data might be sent to and processed in [Insert Jurisdiction], and we’ll put appropriate safeguards in place—like EU Standard Contractual Clauses—where laws require it to protect your information during the transfer.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-medium">20. Changes to this Agreement</h3>
            <p className="text-base font-normal">
            We might update this Agreement from time to time as Tweezers evolves, and if we make significant changes, we’ll let you know by email or through a notice on the Platform. By continuing to use Tweezers after those changes take effect, you’re agreeing to the updated terms.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Policy;
